export default function capitalize(v: string) {
    return v.charAt(0).toUpperCase() + v.slice(1);
}
